import './styles/index.scss'
import 'virtual:uno.css'

import { createApp } from 'vue'

import App from './App.vue'
import { createHead } from '@vueuse/head'
import router from './router'
import pinia from './stores'
import '@/router/routerPermission'
import { setupI18n } from '@/locales/index.js'

import 'virtual:svg-icons-register'

import allDirectives from './directives'

const i18n = await setupI18n()

const app = createApp(App)

const head = createHead()
app.use(head)
app.use(router)
app.use(pinia)
app.use(i18n)

window.addEventListener('vite:preloadError', () => {
  console.log('资源过期，重新加载')
  window.location.reload()
})

// 注册所有指令
allDirectives.forEach(directive => {
  app.use(directive)
})

app.config.globalProperties.$aliYunOss = 'https://aiciting-cn.oss-cn-hangzhou.aliyuncs.com/abroad/'

app.mount('#app')
